"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityModalBody = EntityModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../View/Modals/FormContext");
const GenericComponents_1 = require("../../View/Modals/CommonFormComponents/GenericComponents");
const gusLookupService_1 = require("./gusLookupService");
const EntityGusPanel_1 = require("./EntityGusPanel");
const EntitiesBadges_1 = require("../EntitiesBadges");
/**
 * GUS-4b / D-GUS-6 — nowy podmiot zakłada się Z REJESTRU, nie z klawiatury.
 *
 * Kolejność pól jest z makiety zatwierdzonej przez właściciela 2026-09-09: NIP stoi
 * pierwszy, bo od niego zaczyna się zakładanie podmiotu. Nazwa, adres, REGON i KRS
 * są przy dodawaniu ZABLOKOWANE do wpisywania — wypełnia je „Pobierz z GUS".
 *
 * WYJŚCIE AWARYJNE JEST KONIECZNE, blokada bez niego nie wchodzi w grę: 94 podmioty
 * w słowniku nie mają NIP-u, a jeden („AWT Rekultivace a.s.") jest czeski i polski
 * rejestr go nie zna. Przycisk „Dodaj mimo braku w rejestrze" odblokowuje wpisywanie
 * ręczne. Podmiot dodany tą drogą zostaje przy stanie „nie sprawdzano" — serwer nie
 * przyjmuje statusu z formularza (Entity.ts w PS-nodeJS), więc nie ma tu czego ustawiać.
 *
 * W trybie EDYCJI nic nie jest blokowane: rekord już istnieje, a poprawianie danych
 * ręcznie jest normalną pracą.
 */
function EntityModalBody({ isEditing, initialData }) {
    const { register, reset, getValues, setValue, formState: { dirtyFields, errors, isValid }, trigger, } = (0, FormContext_1.useFormContext)();
    const [gusLoading, setGusLoading] = (0, react_1.useState)(false);
    const [gusError, setGusError] = (0, react_1.useState)(null);
    /** D-GUS-6: przy dodawaniu pola z rejestru odblokowuje albo GUS, albo wyjście awaryjne. */
    const [manualEntry, setManualEntry] = (0, react_1.useState)(false);
    const [gusFilled, setGusFilled] = (0, react_1.useState)(false);
    const registryFieldsLocked = !isEditing && !manualEntry && !gusFilled;
    // NIP-G1 — "Pobierz z GUS": autofill name+address from taxNumber, user can
    // still edit both before saving. BLOCKED until gate G-N1 in prod (503 with
    // a readable message until the owner sets GUS_BIR_KEY).
    //
    // GUS-1: REGON i KRS też wchodzą do formularza. Serwis zwracał je od lipca, tylko
    // nie było gdzie ich zapisać — teraz Entities ma kolumny Regon i Krs. Gdy GUS ich
    // nie podał (osoba fizyczna nie ma KRS-u), pole jest czyszczone, a nie zostawiane
    // z wartością poprzedniego podmiotu.
    const handleFetchFromGus = async () => {
        const nip = getValues("taxNumber");
        setGusError(null);
        setGusLoading(true);
        try {
            const result = await (0, gusLookupService_1.lookupNip)(nip);
            setValue("name", result.name, { shouldDirty: true, shouldValidate: true });
            setValue("address", result.address, { shouldDirty: true, shouldValidate: true });
            setValue("regon", result.regon ?? "", { shouldDirty: true, shouldValidate: true });
            setValue("krs", result.krs ?? "", { shouldDirty: true, shouldValidate: true });
            setGusFilled(true);
        }
        catch (err) {
            setGusError(err instanceof Error ? err.message : "Błąd wyszukiwania GUS");
        }
        finally {
            setGusLoading(false);
        }
    };
    (0, react_1.useEffect)(() => {
        const resetData = {
            name: initialData?.name,
            shortName: initialData?.shortName,
            address: initialData?.address,
            taxNumber: initialData?.taxNumber,
            regon: initialData?.regon,
            krs: initialData?.krs,
            www: initialData?.www,
            email: initialData?.email,
            phone: initialData?.phone,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    const showGusPanel = isEditing &&
        !!initialData?.id &&
        (initialData?.gusStatus === "DIFF" || initialData?.gusStatus === "DIFF_MINOR");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showGusPanel && initialData && (react_1.default.createElement(EntityGusPanel_1.EntityGusPanel, { entityId: initialData.id, initialStatus: initialData.gusStatus, initialCheckedAt: initialData.gusCheckedAt, initialSnapshot: initialData.gusSnapshot, entityValues: {
                name: initialData.name,
                address: initialData.address,
                regon: initialData.regon,
                krs: initialData.krs,
            } })),
        isEditing && !!initialData?.id && !showGusPanel && (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement(EntitiesBadges_1.GusStatusBadge, { status: initialData?.gusStatus, checkedAt: initialData?.gusCheckedAt }))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "taxNumber" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "NIP"),
            react_1.default.createElement("div", { className: "d-flex align-items-start gap-2" },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj numer podatkowy", isInvalid: !!errors?.taxNumber, isValid: !errors?.taxNumber, ...register("taxNumber") }),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", className: "text-nowrap", onClick: handleFetchFromGus, disabled: gusLoading || !!errors?.taxNumber || !getValues("taxNumber") }, gusLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                    "Pobieranie...")) : ("Pobierz z GUS"))),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "taxNumber", errors: errors }),
            gusError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-2 mb-0", onClose: () => setGusError(null), dismissible: true }, gusError))),
        registryFieldsLocked && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border mt-2" },
            react_1.default.createElement("div", null, "Nazw\u0119, adres, REGON i KRS pobiera si\u0119 z rejestru \u2014 wpisz NIP i kliknij \u201EPobierz z GUS\". Dzi\u0119ki temu rozbie\u017Cno\u015Bci nie powstaj\u0105 ju\u017C przy zak\u0142adaniu podmiotu."),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", className: "mt-2", onClick: () => setManualEntry(true) }, "Dodaj mimo braku w rejestrze"))),
        !isEditing && manualEntry && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mt-2" }, "Dane wpisujesz r\u0119cznie \u2014 rejestr tego podmiotu nie zna albo nie ma on polskiego NIP-u. Podmiot zostanie zapisany ze stanem \u201EGUS: nie sprawdzano\".")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "name" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, placeholder: registryFieldsLocked ? "Wypełni się po pobraniu z GUS" : "Podaj nazwę", disabled: registryFieldsLocked, isInvalid: !!errors?.name, isValid: !errors?.name, ...register("name") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "name", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "address" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Adres"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: registryFieldsLocked ? "Wypełni się po pobraniu z GUS" : "Podaj adres", disabled: registryFieldsLocked, isInvalid: !!errors?.address, isValid: !errors?.address, ...register("address") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "address", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "regon" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "REGON"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj REGON (wype\u0142nia si\u0119 przy pobraniu z GUS)", maxLength: 14, disabled: registryFieldsLocked, isInvalid: !!errors?.regon, isValid: !errors?.regon, ...register("regon") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "regon", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "krs" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "KRS"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj numer KRS (wype\u0142nia si\u0119 przy pobraniu z GUS)", maxLength: 10, disabled: registryFieldsLocked, isInvalid: !!errors?.krs, isValid: !errors?.krs, ...register("krs") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "krs", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "shortName" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Skr\u00F3cona nazwa"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj skr\u00F3con\u0105 nazw\u0119 (max 15 znak\u00F3w) (Potrzebna do nazwy folderu kontraktu na dysku)", maxLength: 15, isInvalid: !!errors?.shortName, isValid: !errors?.shortName, ...register("shortName") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "shortName", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "www" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "WWW"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj adres strony www", isInvalid: !!errors?.www, isValid: !errors?.www, ...register("www") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "www", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "email" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Email"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "email", placeholder: "Podaj adres email", isInvalid: !!errors?.email, isValid: !errors?.email, ...register("email") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "email", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "phone" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Telefon"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj numer telefonu", isInvalid: !!errors?.phone, isValid: !errors?.phone, ...register("phone") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "phone", errors: errors }))));
}
